import React, { useState, useEffect } from 'react';
import Wrapper from './styles';
import axios from 'axios';
import { useCartContext } from '../../context/cart_context';
import { useUserContext } from '../../context/user_context';
import { useOrderContext } from '../../context/order_context';
import { formatPrice } from '../../utils/helpers';
import { useHistory} from 'react-router-dom';
import { toast } from 'react-toastify';
import useRazorpay from 'react-razorpay';
import Loading from '../Loading';

const CheckoutForm = ({ onCancel }) => {
  const {
    cart,
    total_amount,
    shipping_fee,
    clearCart,
    couponDiscount,
    total_tax,
  } = useCartContext();
  const { shipping, placeOrder, paymentMethod } = useOrderContext();
  const { currentUser } = useUserContext();
  const history = useHistory();
  const [succeeded, setSucceeded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  let taxPrice = 0;
  cart.map((e) => (taxPrice += (e.price * e.amount * e.taxPrice) / 10000));
  let paidAmount = total_amount-couponDiscount;
 

  useEffect(() => {
    async function placeOrderWithPayment() {
      if(!currentUser.email){
        toast.error("Please update your profile for sending email")
        return history.push("/profile")
      }
      setIsLoading(true);
      const amount = Math.round(paidAmount);
      const currency = 'INR';
      const receiptId = '1234567890';
      let orderAmount = Math.round(paidAmount);
      const paymentMethod = 'online';
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_HOST}/order`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            amount: amount*100,
            currency,
            receipt: receiptId
          }),
        }
      );
      
      const order = await response.json();
      let orderId = order.id;
      let orderRes = await placeOrder(orderId, paymentMethod);
      // await updateProductQuantity()
      console.log(orderRes);
      setIsLoading(false);
      let primaryId = orderRes?.id;

      let options = { orderId, amount, primaryId, cust_id: currentUser?.id };
      const hdfcResponse = await axios.post(
        `${process.env.REACT_APP_BACKEND_HOST}/api/hdfc/initiateJuspayPayment`,
        options
      );

      if (hdfcResponse.data.payment_links?.web) {
        window.location.href = hdfcResponse.data.payment_links.web;
      } else {
        console.error('Payment link not found', hdfcResponse.data);
      }
    }

    placeOrderWithPayment();
  }, [placeOrder, clearCart, history, onCancel]);

  return (
    <div>
      {!isLoading&&succeeded ? (
        <article>
          <h4>Thank You!</h4>
          <h4>Your order was successfully placed</h4>
          <h4>Redirecting to Order page shortly</h4>
        </article>
      ) : (
         !isLoading &&!succeeded ? (<article>
          <h4>
            Hello,
            {currentUser &&
              (currentUser?.name ? currentUser.name : currentUser.email)}
          </h4>
          <p>Your total is {paidAmount}</p>
        </article>):
        (<Loading/>)
      )}
    </div>
  );
};

const StripeCheckout = ({ onCancel }) => {
  return (
    <Wrapper>
       <CheckoutForm onCancel={onCancel} /> 
    </Wrapper>
  );
};

export default StripeCheckout;
